import { useEffect, useState } from "react";

import { useParams } from "react-router-dom";

import { Stack } from "@mui/material";
import Grid from "@mui/material/Grid";
import { PageContainer } from "@/features/ui";

import { PromotionCodesSection } from "@/features/promotion-codes";
import {
  PromotionDetailGeneralInformationSection,
  PromotionDetailOutletAvailabilitySection,
  PromotionDetailUsageLimitsSection,
  PromotionDetailValiditySection,
} from "@/features/promotions";
import { apiClient } from "@/features/shared";
import { CenteredLoading } from "@/features/ui";

export const Promotion = () => {
  const { promotionId } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [promotion, setPromotion] = useState(null);

  useEffect(() => {
    const fetchPromotion = async () => {
      setIsLoading(true);
      try {
        const {
          data: { data },
        } = await apiClient.get(`promotions/${promotionId}`, {
          params: {
            withPromotionCampaign: true,
            withPromotionOutlets: true,
          },
        });
        setPromotion(data);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPromotion();
  }, [promotionId]);

  if (isLoading) {
    return <CenteredLoading />;
  }

  return (
    <PageContainer
      maxWidth="xl"
      title="Detail Promosi"
      breadcrumbs={[
        { title: "Promosi", path: "/setting/promotions" },
        {
          title: promotion?.name || promotionId,
          path: `/setting/promotions/${promotionId}`,
        },
      ]}
    >
      <Stack spacing={3}>
        <PromotionDetailGeneralInformationSection promotion={promotion} />
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 6 }}>
            <PromotionDetailValiditySection promotion={promotion} />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <PromotionDetailUsageLimitsSection promotion={promotion} />
          </Grid>
        </Grid>
        <PromotionDetailOutletAvailabilitySection promotion={promotion} />
        <PromotionCodesSection promotion={promotion} />
      </Stack>
    </PageContainer>
  );
};
